import React from "react";
import Marquee from "react-fast-marquee";
import { Reveal } from "@/components/common/Reveal";
import SectionLabel from "@/components/common/SectionLabel";
import { BRANDS } from "@/data/site";

export default function BrandsMarquee() {
  return (
    <section data-testid="brands-section" className="bg-white py-20 md:py-28 border-t border-black/5">
      <div className="container-gema">
        <Reveal>
          <SectionLabel index="04" dark={false}>Trabajamos con Marcas Reconocidas</SectionLabel>
        </Reveal>
        <Reveal delay={0.1}>
          <p className="text-black/50 mt-6 max-w-2xl leading-relaxed">
            Utilizamos repuestos y componentes de fabricantes reconocidos para garantizar confiabilidad,
            seguridad y un alto desempeño en cada servicio realizado.
          </p>
        </Reveal>
      </div>

      <div className="mt-14">
        <Marquee gradient gradientColor="#ffffff" gradientWidth={120} speed={40} pauseOnHover>
          {BRANDS.map((b, i) => (
            <span
              key={i}
              className="mx-10 font-heading font-black text-2xl md:text-3xl uppercase tracking-tight text-black/25 hover:text-gema-red transition-colors duration-300 select-none"
            >
              {b}
            </span>
          ))}
        </Marquee>
      </div>
    </section>
  );
}
